// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"emails_modalBodyStyle__xvslV","modal":"emails_modal__edBG2"};